import React from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

import { OverviewTooltipBackground } from 'assets/SVGIcons'
import { formatDate, LOCAL_DATE_FORMAT_MONTH_YEAR } from 'utils/date'

const styles = theme => ({
  root: {
    width: 'auto',
    zIndex: 99999,
    minWidth: 275,
    position: 'absolute',
    pointerEvents: 'none',
    padding: theme.spacing(6),
    transition: 'all .3s ease',
    animation: 'fadeIn .3s ease',
    marginLeft: -theme.spacing(0.5),
    paddingBottom: theme.spacing(8),
  },
  value: {
    marginRight: 15,
  },
  description: {
    color: theme.palette.disabled.main,
  },
  date: {
    marginTop: theme.spacing(0.5),
  },
  background: {
    top: 0,
    left: 0,
    bottom: 0,
    zIndex: -1,
    position: 'absolute',
  },
  flipped: {
    marginLeft: theme.spacing(3),
    transform: 'translateX(-100%)',
  },
  flippedBackground: {
    transform: 'scaleX(-1) translateX(20px)',
  },
})

const OverviewGraphTooltip = ({
  classes, data, x, y, open, flipped
}) => {
  return open ? (
    <div
      className={classNames(classes.root, flipped && classes.flipped)}
      style={{ top: y, left: x }}>
      <Typography className={classes.value}>
        {data.totalKills}{' '}
        <span className={classes.description}>Total kills this month</span>
      </Typography>
      <Typography className={classes.value}>
        {data.totalTrapsSynced}/{data.totalTraps}{' '}
        <span className={classes.description}>Traps synced</span>
      </Typography>
      <Typography className={classes.date} color="primary">
        {formatDate(data.date, LOCAL_DATE_FORMAT_MONTH_YEAR)}
      </Typography>
      <OverviewTooltipBackground
        className={classNames(
          classes.background,
          flipped && classes.flippedBackground
        )}
      />
    </div>
  ) : null
}

OverviewGraphTooltip.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  open: PropTypes.bool,
  data: PropTypes.object,
  flipped: PropTypes.bool,
  classes: PropTypes.object,
}

export default withStyles(styles)(OverviewGraphTooltip)



// WEBPACK FOOTER //
// ./src/components/atoms/OverviewGraphTooltip.js